import { useLocation } from "react-router-dom";

export function useURLParams() {
  return new URLSearchParams(useLocation().search);
}
